import { useNavigate } from "react-router-dom";
import { TextField, Button, CardMedia, Input, Tabs, Box, Tab, SelectChangeEvent, MenuItem, Checkbox, ListItemText, Select } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React, { ChangeEvent, useState } from "react";
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const ManageProfile = () => {

  const navigate = useNavigate();

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const handleNextTab = () => {
    if (valueTabs < 4) {
      setValueTabs((prev) => prev + 1);
    }
  };
  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const CustomTabPanel: React.FC<TabPanelProps> = ({
    children,
    value,
    index,
    ...other
  }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add login logic here
    navigate("/dashboard");
  };
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });
  const [valueTabs, setValueTabs] = useState<number>(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleSelectAll = (
    event: React.MouseEvent,
    allItems: string[],
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    if (selectedItems.length === allItems.length) setSelectedItems([]);
    else setSelectedItems(allItems);
  };
  const [openCategory, setOpenCategory] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<string[]>([]);
  const categories = ["Fashion", "Beauty", "Electronics", "Books"];
  const subCategories = ["Men", "Women", "Kids", "Accessories"];
  const handleItemClick = (
    event: React.MouseEvent,
    value: string,
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    const selectedIndex = selectedItems.indexOf(value);
    let newSelected: string[] = [];

    if (selectedIndex === -1) newSelected = [...selectedItems, value];
    else newSelected = selectedItems.filter((v) => v !== value);

    setSelectedItems(newSelected);
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Profile
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="view product tabs"
                className="custom_tabs_links tabs_img"
              >
                <Tab label="General Details" {...a11yProps(0)} />
                <Tab label="Address Details" {...a11yProps(1)} />
                <Tab
                icon={
                  <InfoIcon/>
                } label="Bank Account Details" {...a11yProps(2)} />
                <Tab label="Additional Documents" {...a11yProps(3)} />
              </Tabs>
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary"><EditIcon /> Edit Profile</Button>
          </div>
        </div>
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={handleSubmit}>
            {/* IMAGE UPLOAD */}
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file">Upload Logo</label>
                {image ? (
                  <div className="upload_image br_none" >
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image br_none" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = (event.target as HTMLInputElement).files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        } else {
                          setAlertType(0);
                          setShowAlert(true);
                          setAlertMessage("This field only accepts images.");
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/user_placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* FULL NAME */}
              <div className="control_group w_33">
                <label htmlFor="fullName">Full Name</label>
                <TextField
                  id="fullName"
                  name="fullName"
                  placeholder="Enter Full Name"
                  fullWidth
                />
              </div>

              {/* BUSINESS NAME */}
              <div className="control_group w_33">
                <label htmlFor="businessName">Business Name</label>
                <TextField
                  id="businessName"
                  name="businessName"
                  placeholder="Enter Business Name"
                  fullWidth
                />
              </div>

              {/* CONTACT EMAIL */}
              <div className="control_group w_33">
                <label htmlFor="email">Contact Email</label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Enter Email Address"
                  fullWidth
                />
              </div>

              {/* CONTACT PHONE */}
              <div className="control_group w_33">
                <label htmlFor="contactPhone">Contact Phone</label>
                <TextField
                  id="contactPhone"
                  name="contactPhone"
                  placeholder="+971"
                  fullWidth
                />
              </div>

              {/* SERVICE COVERAGE AREA (LOCATIONS) */}
              <div className="control_group w_33">
                <label>Service Coverage Area (Locations)</label>
                <Select fullWidth value={"default"}>
                  <MenuItem disabled value="default">Select</MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm al-Quwain">Umm al-Quwain</MenuItem>
                  <MenuItem value="Ras al-Khaimah">Ras al-Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
              </div>

              {/* CATEGORY MULTI SELECT */}
              <div className="control_group w_33">
                <label htmlFor="category">Category</label>
                <Select
                  multiple
                  displayEmpty
                  open={openCategory}
                  onOpen={() => setOpenCategory(true)}
                  onClose={() => setOpenCategory(false)}
                  value={selectedCategories}
                  renderValue={(selected) =>
                    selected.length === 0 ? (
                      <span style={{ color: "#999" }}>Select Category</span>
                    ) : (
                      (selected as string[]).join(", ")
                    )
                  }
                  fullWidth
                  MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
                >
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(e, categories, selectedCategories, setSelectedCategories)
                    }
                  >
                    <Checkbox
                      checked={
                        categories.length > 0 &&
                        selectedCategories.length === categories.length
                      }
                      indeterminate={
                        selectedCategories.length > 0 &&
                        selectedCategories.length < categories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedCategories.length === categories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {categories.map((cat) => (
                    <MenuItem
                      key={cat}
                      value={cat}
                      onClick={(e) =>
                        handleItemClick(e, cat, selectedCategories, setSelectedCategories)
                      }
                    >
                      <Checkbox checked={selectedCategories.includes(cat)} />
                      <ListItemText primary={cat} />
                    </MenuItem>
                  ))}
                </Select>
              </div>

              {/* BUSINESS DESCRIPTION */}
              <div className="control_group w_100 ai_rec_btn">
                <label htmlFor="businessDescription">
                  Business Description
                  <p style={{ margin: 0 }}>(250 characters maximum)</p>
                </label>
                <TextField
                  id="businessDescription"
                  name="businessDescription"
                  placeholder="Enter Business Description"
                  multiline
                  fullWidth
                />
               
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={1}>
          <form className="form">
            <div className="gap_p">

              {/* ADDRESS DETAILS */}
              <div className="control_group w_50">
                <label htmlFor="addressDetails">Address Details</label>
                <TextField
                  id="addressDetails"
                  name="addressDetails"
                  placeholder="Enter Full Address Details"
                  fullWidth
                />
              </div>

              {/* EMIRATE */}
              <div className="control_group w_50">
                <label htmlFor="emirate">Emirate</label>
                <Select
                  id="emirate"
                  fullWidth
                  value={"default"}
                >
                  <MenuItem disabled value="default">
                    Select Emirate
                  </MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm Al Quwain">Umm Al Quwain</MenuItem>
                  <MenuItem value="Ras Al Khaimah">Ras Al Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
              </div>

              {/* CITY */}
              <div className="control_group w_50">
                <label htmlFor="city">City</label>
                <TextField
                  id="city"
                  name="city"
                  placeholder="Enter City"
                  fullWidth
                />
              </div>

              {/* STREET NAME */}
              <div className="control_group w_50">
                <label htmlFor="streetName">Street Name</label>
                <TextField
                  id="streetName"
                  name="streetName"
                  placeholder="Enter Street Name"
                  fullWidth
                />
              </div>

              {/* BUILDING NAME/NUMBER */}
              <div className="control_group w_50">
                <label htmlFor="buildingName">Building Name/Number</label>
                <TextField
                  id="buildingName"
                  name="buildingName"
                  placeholder="Enter Building Name or Number"
                  fullWidth
                />
              </div>
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" >
                  Save
                </Button>
              </div>
            </div>

          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <form className="form wrap_viewDemo_steps">
            <div className="gap_p bank_details">

              {/* BANK ACCOUNT NAME */}
              <div className="control_group w_50">
                <label htmlFor="bankAccountName">Bank Account Name (Mandatory)</label>
                <TextField
                  id="bankAccountName"
                  name="bankAccountName"
                  placeholder="Enter Bank Account Name"
                  fullWidth
                />
              </div>

              {/* BANK NAME */}
              <div className="control_group w_50">
                <label htmlFor="bankName">Bank Name (Mandatory)</label>
                <Select
                  id="bankName"
                  fullWidth
                  value="default"
                >
                  <MenuItem disabled value="default">
                    Select Bank
                  </MenuItem>
                  <MenuItem value="PNB">PNB</MenuItem>
                  <MenuItem value="SBI">SBI</MenuItem>
                  <MenuItem value="HDFC">HDFC</MenuItem>
                  <MenuItem value="ICICI">ICICI</MenuItem>
                </Select>
              </div>

              {/* IBAN */}
              <div className="control_group w_50">
                <label htmlFor="iban">IBAN (Mandatory)</label>
                <TextField
                  id="iban"
                  name="iban"
                  placeholder="Enter IBAN Number"
                  fullWidth
                />
              </div>

              {/* SWIFT / BIC CODE */}
              <div className="control_group w_50">
                <label htmlFor="swiftCode">Swift Code (Optional)</label>
                <TextField
                  id="swiftCode"
                  name="swiftCode"
                  placeholder="Enter Swift/BIC Code"
                  fullWidth
                />
              </div>

              {/* BANK DOCUMENT UPLOAD */}
              <div className="control_group w_100">
                <label htmlFor="bankDocument">Bank Document Upload (Optional)</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <form className="form wrap_viewDemo_steps" >
            <div className="gap_p bank_details">
              <div className="control_group w_50">
                <label htmlFor="bankDocument">Document 1</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>
              <div className="control_group w_50">
                <label htmlFor="bankDocument">Document 2</label>
                <div className="upload_box">
                  <label className='upload_action' >
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>

              </div>
              <div className="form_btn">
                <Button className="btn btn_primary" variant="contained" >
                  Save
                </Button>
              </div>
            </div>
          </form>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageProfile;
